export const boundPosition = (position, element) => {
    return {
        x: Math.max(0, Math.min(position.x, document.documentElement.clientWidth - element.offsetWidth)),
        y: Math.max(0, Math.min(position.y, document.documentElement.clientHeight - element.offsetHeight)),
    };
};
export const offsetPosition = (position, offset) => ({
    x: position.x + offset,
    y: position.y + offset,
});
